export default function creatBlobFromBase64(content, contentType) {
  // decode base64 string, remove space for IE compatibility
  // eslint-disable-next-line no-undef
  const binary = atob(content.replace(/\s/g, ''));
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }

  // create the blob object
  return new Blob([view], { type: contentType });
}
